<template>
  <v-card :loading="loading">
    <v-card-title class="headline font-weight-thin">Delete Confirmation</v-card-title>
    <v-card-text>
      Are you sure you want to delete
      <span class="font-weight-bold">{{ releaseNote.title }} (ID: {{ releaseNote.id }})</span>?
    </v-card-text>
    <v-card-actions class="pa-4" v-show="!loading">
      <v-spacer></v-spacer>
      <v-btn @click="cancel" class="mr-2" data-cy="cancelDelete" outlined>Cancel</v-btn>
      <v-btn class="elevation-0 font-weight-bold" color="red" data-cy="confirmDelete" @click="submit" outlined
        >Delete</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  computed: {
    loading() {
      return !this.releaseNote.id;
    },
  },
  methods: {
    cancel() {
      this.$emit("setDialog", false);
    },
    async submit() {
      const { id, title } = this.releaseNote;

      try {
        await this.deleteRecord(id);
        this.$emit("setDialog", false);
        this.$notifySuccess({ message: `Successfully deleted ${title}` });
      } catch (e) {
        return this.$notifyError({
          message: `Could not delete releaseNote value.`,
        });
      }
      try {
        await this.fetchList({ id: this.packId });
        this.$router.push({
          name: "releaseNoteList",
          params: {
            packId: this.packId,
          },
        });
      } catch (e) {
        console.error(e);
        this.$notifyError({
          message: `Could not refresh release note list.`,
        });
      }
    },
    ...mapActions({
      deleteRecord: "releaseNote/deleteRecord",
      fetchList: "releaseNote/getReleaseNoteList",
    }),
  },
  props: { releaseNote: { required: true, type: Object }, packId: { required: true, type: Number } },
};
</script>
